export const SIGN_IN = 'signIn';
export const SIGN_OUT = 'signOut';

export const GET_TOKEN = 'getToken';
export const GEN_TOKEN = 'genToken';

export const GET_USER_INFO = 'getUserInfo';
export const GET_USER = 'getUser';
export const ADD_USER = 'addUser';
export const UPDATE_USER = 'updateUser';
export const DELETE_USER = 'deleteUser';


export const GET_ADMIN = 'getAdmin';
export const ADD_ADMIN = 'addAdmin';
export const UPDATE_ADMIN = 'updateAdmin';
export const DELETE_ADMIN = 'deleteAdmin';

export const GET_SETTING = 'getSetting';
export const UPDATE_SETTING = 'updateSetting';

export const GET_CODE = 'getCode';
export const GET_NAME_LIST = 'getNameList';
export const SEARCH_CODE = 'searchCode';

export const GENERATE_CODE = 'generateCode';
export const UPDATE_CODE = 'updateCode';
export const VERIFY_CODE = 'verifyCode';

export const GET_CODE_STAT = 'getCodeState';


export const GET_BACKGROUND = 'getBackground';
export const ADD_BACKGROUND = 'addBackground';
export const DELETE_BACKGROUND = 'deleteBackground';
